export default class CustomError extends Error {
  public errorCode: number;

  constructor(message = 'Error occurred', errorCode: number = 500) {
    super(message);
    this.name = 'CustomError';
    this.errorCode = errorCode;
  }
}
